import submit from '@app/person/action/submit'
import detail from '@app/person/action/detail'
import newPerson from '@app/person/action/new'
import create from '@app/person/action/create'
import edit from '@app/person/action/edit'
import index from '@app/person/action/index'
import contact from '@app/person/action/invite/contact'
import colleague from '@app/_shared/action/invite/colleague'
import noop from '@gaia/util/noop/action'
import submitFavorite from 'app/_shared/action/favorite/submit'
import successFavorite from 'app/_shared/action/favorite/success'
import organisation from '@app/person/action/form/organisation'
import bulk from '@app/person/action/bulk'

export default {
  index,
  new: newPerson,
  create,
  edit,
  bulk,
  submit,
  newContact: contact,
  newColleague: colleague,
  organisation,
  requests: noop,
  detail,

  submitFavorite,
  successFavorite,
}
